import React from 'react';

const FLAG_PLACEHOLDER_STYLE: React.CSSProperties = {
  width: 24,
  height: 16,
  marginLeft: '5px',
  marginRight: '10px',
  marginTop: '3px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 9,
  fontWeight: 600,
  backgroundColor: 'var(--color-surface, #e8e8e8)',
  color: 'var(--color-text-muted, #666)',
  borderRadius: 2,
};

export function CountryFlagImage({
  src,
  alt,
  cca2,
}: {
  src: string | undefined;
  alt: string;
  cca2: string;
}): React.JSX.Element {
  const [errored, setErrored] = React.useState(false);
  if (errored || !src) {
    return (
      <span style={FLAG_PLACEHOLDER_STYLE} title={alt || cca2}>
        {cca2 || '?'}
      </span>
    );
  }
  return (
    <img
      width={24}
      height={16}
      alt={alt}
      src={src}
      style={{
        marginLeft: '5px',
        marginRight: '10px',
        marginTop: '3px',
      }}
      onError={() => setErrored(true)}
    />
  );
}
